
export default {
  placesCarousel: {
    layer: 'Camada',
    lat: 'Lat.',
    lon: 'Lon.',
    notAvailable: 'Não disponível',
    placeDetails: 'Detalhes do local',
    next: 'Próximo bloco',
    prev: 'Bloco anterior',
    directionsTo: 'Direções',
    distance: 'Distância',
    distanceFromLocationMarkedOnTheMap: 'Distância aproximada do local marcado no mapa',
    selectPlace: 'Selecionar'
  }
}
